<!-- 服务商详情 -->
<template>
  <div class="serviceDetails">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <div class="barPath width">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/release' }">供需市场</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/serviceList' }">服务商列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{info.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="introduction width">
      <div class="intr_img">
        <img :src="info.cover_logo" alt srcset />
      </div>
      <div class="intr_name">
        <div class="title">{{info.name}}</div>
        <div class="sys">
          <span class="ren">{{info.is_renzhen==1?'已验证':'未验证'}}</span>
          <span class="rf">软件服务商</span>
        </div>
        <div class="web">{{info.website}}</div>
        <div class="address">地址：{{info.address}}</div>
      </div>
      <div class="intr_contact">
        <div class="name">联系人：{{info.contacts}}</div>
        <div class="ipone">联系电话：{{info.phone}}</div>
        <div class="emaill">联系邮箱：{{info.conemail}}</div>
      </div>
    </div>
    <div class="intr_introduction width">
      <div class="title">企业简介</div>
      <div class="intr_content">
        <div class="item">
          <div class="pp">
            <span>公司全称：</span>
            <span>{{info.name}}</span>
          </div>
          <div class="pp">
            <span>注册资本：</span>
            <span>{{info.capital}}万元人民币</span>
          </div>
          <div class="pp">
            <span>公司规模：</span>
            <span>{{info.size}}</span>
          </div>
        </div>
        <div class="item">
          <div class="pp">
            <span>法定代表人：</span>
            <span>{{info.representative}}</span>
          </div>
          <div class="pp">
            <span>企业类型：</span>
            <span>{{info.pr_type}}</span>
          </div>
          <div class="pp">
            <span>所属地区：</span>
            <span>{{info.region}}</span>
          </div>
        </div>
        <div class="item">
          <div class="pp">
            <span>成立日期：</span>
            <span>{{info.create_time | formatDate3}}</span>
          </div>
          <div class="pp">
            <span>所属行业：</span>
            <span>{{info.industry}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="intr_introduction width">
      <div class="title">资质证书</div>
      <div class="table">
        <el-table :data="zizhi" border size="small">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="type" label="证书类型" width="180"></el-table-column>
          <el-table-column prop="name" label="证书名称" width="180"></el-table-column>
          <el-table-column prop="number" label="证书编号"></el-table-column>
          <el-table-column prop="create_time" :formatter="dateFormat" label="发证日期"></el-table-column>
          <el-table-column prop="end_time" :formatter="dateFormat" label="截止日期"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="intr_introduction width">
      <div class="title">软件著作权</div>
      <div class="table">
        <el-table :data="ruan" border size="small">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="name" label="软件名称" width="180"></el-table-column>
          <el-table-column prop="lever" label="版本号" width="180"></el-table-column>
          <el-table-column prop="create_time" label="发布日期"></el-table-column>
          <el-table-column prop="abbreviation" label="软件简称"></el-table-column>
          <el-table-column prop="regnumber" label="登记号"></el-table-column>
          <el-table-column prop="regtime" :formatter="dateFormat" label="登记批准日期"></el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Footer from '../components/Footer.vue'

import moment from 'moment'
export default {
  name: '',
  components: { TopImg, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '服务商列表',
        bgImg: require('../assets/images/u3244.jpg'),
        content: '为您提供优质服务商，提供优质的服务',
        bl: false,
      },

      info: {},
      ruan: [],
      zizhi: [],
      infoPar: '',
    }
  },
  computed: {},
  watch: {},
  created() {
    var zg = Object.values(this.$route.params)
    if (zg.length > 0) {
      sessionStorage.setItem('appinfoPars', JSON.stringify(this.$route.params))
    }
    this.getListData()
  },
  mounted() {},
  methods: {
    async getListData() {
      this.infoPar = JSON.parse(sessionStorage.getItem('appinfoPars'))
      const res = await this.$http.post('/getProviderinfo', this.infoPar)
      this.info = res.data.data.info
      this.ruan = res.data.data.ruan
      this.zizhi = res.data.data.zizhi
    },
    dateFormat(row, column) {
      var date = row[column.property]

      if (date == undefined) {
        return ''
      }

      // return moment(date).format('YYYY-MM-DD HH:mm:ss')
      return moment(date).format('YYYY-MM-DD')
    },
  },
}
</script>
<style lang="less" scoped>
.barPath {
  height: 48px;
  line-height: 48px;
  background-color: #fff;
  padding-left: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .el-breadcrumb {
    line-height: 48px;
    font-size: 16px !important;
  }
}
.introduction {
  display: flex;
  padding: 20px 10px;
  background-color: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .intr_img {
    flex: 1;
    img {
      width: 100%;
      min-width: 200px;
      min-height: 130px;
    }
  }
  .intr_name {
    flex: 3;
    margin-left: 30px;
    .title {
      font-weight: 700;
      font-size: 16px;
      margin-bottom: 20px;
    }
    .sys {
      display: flex;
      margin-bottom: 20px;
      .ren {
        flex: 1;
        max-width: 120px;
        color: #16c31d;
      }
      .rf {
        color: #f59a23;
      }
    }
    .web {
      margin-bottom: 20px;
    }
  }
  .intr_contact {
    flex: 3;
    margin-top: 42px;
    .name,
    .ipone {
      margin-bottom: 20px;
    }
  }
}
.intr_introduction {
  margin-bottom: 10px;
  padding: 20px 10px;
  background-color: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  .title {
    font-weight: 700;
    font-size: 18px;
    border-left: 4px solid #1677ff;
    padding-left: 10px;
    margin-bottom: 30px;
  }
  .intr_content {
    display: flex;
    .item {
      flex: 1;
      .pp {
        margin-bottom: 20px;
        span:first-child {
          display: inline-block;
          width: 100px;
        }
      }
    }
  }
}
</style>
